$(() => {
    const { collapsedInfoHeight, collapsedInfoHeightDesktop, displayIsiPreview } =
        window.__VUMEDI_SAFETY_INFO_CONTEXT__;

    function setUpIsiPopup(className, safetyInfoTag, safetyInfoHeight) {
        safetyInfoTag.css('top', `${safetyInfoHeight}%`);
        // Event handler for expanding safety information
        safetyInfoTag.on('click tap', () => {
            if (parseFloat(safetyInfoTag.css('top')) !== 0) {
                // is collapsed
                safetyInfoTag.css('top', '0%');
            } else {
                safetyInfoTag.css('top', `${safetyInfoHeight}%`);
            }

            safetyInfoTag.toggleClass(className);
        });
    }

    function onDesktopForced(isNarrowScreen) {
        const safetyInfoTag = $('.isi-preview-safety-information');
        const safetyInfoHeight = isNarrowScreen ? 100 - collapsedInfoHeight : 100 - collapsedInfoHeightDesktop;
        setUpIsiPopup('isi-preview-expand', safetyInfoTag, safetyInfoHeight);
    }

    function onNarrowScreen() {
        const safetyInfoTag = $('.safety-information');
        const safetyInfoHeight = 100 - collapsedInfoHeight;
        const safetyInfoClassName = 'isi-expand';
        setUpIsiPopup(safetyInfoClassName, safetyInfoTag, safetyInfoHeight);
    }

    function onWideScreen() {
        const safetyInfoTag = $('.safety-information');
        safetyInfoTag.css('top', '');
        safetyInfoTag.removeClass('isi-expand');
        safetyInfoTag.off('click tap');
    }

    // set up event listener
    function onScreenWidthChange(event) {
        const isNarrowScreen = event.matches;
        if (displayIsiPreview) {
            onDesktopForced(isNarrowScreen);
        } else if (isNarrowScreen) {
            onNarrowScreen();
        } else {
            onWideScreen();
        }
    }
    const mql = window.matchMedia('only screen and (max-width: 1024px)');
    mql.addEventListener('change', onScreenWidthChange);

    // trigger once
    onScreenWidthChange(mql);
});
